import homeController from './home/homeController';
import apiScreenController from './api/screenController';
import apiDisplayController from './api/displayController';

export default new Map([
  ['home', homeController],
  ['api-screen', apiScreenController],
  ['api-display', apiDisplayController],
]);
